import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostAttachmentFileUpload(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/file/upload`,
    METHOD.POST,
    params
  )
}

export async function rqtPostAttachmentList(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/query`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostAttachmentDownload(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/download`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { responseType: 'blob' }
  )
}

export async function rqtPostAttachmentBatchDownload(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/batch/download`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { responseType: 'blob' }
  )
}

export async function rqtPostAttachmentBatchDelete(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/batch/delete`,
    METHOD.DELETE_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetImgDownload(params) {
  return request(
    `${BASE_URL}/provider/common/attachment/img/download`,
    METHOD.GET,
    params,
    { responseType: 'blob' }
  )
}

export function getFileUrl({ savePath, fileName }) {
  return `${BASE_URL}/provider/common/attachment/img/download?savePath=${encodeURIComponent(
    savePath
  )}&fileName=${fileName}`
}
